import React, { useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import contactSchema from "./validationSchema";
import TextInput from "../../common/TextInput";
import TextArea from "../../common/TextArea";
import Alert from "../../common/Alert";
import Button from "../../common/Button";

import { clearAlert } from "./services";
import { submitContactForm } from "./services";
import { useContact } from "./store";

// import { useUserDetails } from "../../UserDetails/store";
interface Props {
  closeModal: () => void;
}

const ContactUs: React.FunctionComponent<Props> = (props: Props) => {
  const { t } = useTranslation();
  const { contactState, dispatch } = useContact();
  const { contact, error, isLoading } = contactState;
  const { closeModal } = props;

  const handleCloseModal = (): void => {
    closeModal();
    clearAlert(dispatch);
    formik.resetForm();
  };
  const formik = useFormik({
    initialValues: {
      fullName: "",
      phoneNo: "",
      company: "",
      jobTitle: "",
      email: "",
      notes: "",
    },
    validationSchema: contactSchema,
    onSubmit: (values) => {
      const { fullName, ...rest } = values;
      const fullNameArray = fullName.split(" ");
      submitContactForm(
        {
          firstName: fullNameArray[1] ? fullNameArray[0] : null,
          lastName:
            fullNameArray.length > 2
              ? fullNameArray.slice(1).join(" ")
              : fullNameArray[1] || fullNameArray[0],
          ...rest,
        },
        dispatch
      );
    },
  });

  return (
    <>
      <div>
        <div className="justify-center max-w-md p-6 w-full">
          <div className="flex justify-between items-start pb-4 w-full">
            <div className=" pb-4 ">
              <h4 className="text-neutral-charcoal pr-2 pb-2">
                {t("contactus.title")}
              </h4>
              <p> {t("contactus.subtitle")}</p>
            </div>

            <button
              type="button"
              className="p-2 pr-1"
              onClick={handleCloseModal}
            >
              <i className="fa-lg fa-times fas" />
            </button>
          </div>
          {!!error.reason && (
            <Alert
              alertType="error"
              title={t(`errorResponseType.${error.type}.${error.reason}`)}
            />
          )}
          {!error.reason && !!error.message && (
            <Alert alertType="error" title={error.message} />
          )}

          {!!contact.message && (
            <Alert alertType="success" title={contact.message} />
          )}
          <p className="pb-4 body-text-2"> {t("contactus.description")}</p>

          <form onSubmit={formik.handleSubmit}>
            <div className="relative w-full mb-3">
              <TextInput
                name="fullName"
                type="text"
                className="trans"
                placeHolder={t("contactus.placeholder.fullName")}
                value={formik.values.fullName}
                onChange={formik.handleChange}
                error={formik.errors.fullName}
              />
            </div>
            <div className="relative w-full mb-3">
              <TextInput
                name="phoneNo"
                type="text"
                className="trans"
                placeHolder={t("contactus.placeholder.phoneNo")}
                value={formik.values.phoneNo}
                onChange={formik.handleChange}
                error={formik.errors.phoneNo}
              />
            </div>

            <div className="relative w-full mb-3">
              <TextInput
                name="email"
                type="email"
                className="trans"
                placeHolder={t("contactus.placeholder.email")}
                value={formik.values.email}
                onChange={formik.handleChange}
                error={formik.errors.email}
              />
            </div>
            <div className="relative w-full mb-3">
              <TextInput
                name="company"
                type="text"
                className="trans"
                placeHolder={t("contactus.placeholder.company")}
                value={formik.values.company}
                onChange={formik.handleChange}
                error={formik.errors.company}
              />
            </div>
            <div className="relative w-full mb-3">
              <TextInput
                name="jobTitle"
                type="text"
                className="trans"
                placeHolder={t("contactus.placeholder.jobTitle")}
                value={formik.values.jobTitle}
                onChange={formik.handleChange}
                error={formik.errors.jobTitle}
              />
            </div>

            <div className="relative w-full mb-10">
              <TextArea
                name="notes"
                className="trans"
                placeHolder={t("contactus.placeholder.notes")}
                value={formik.values.notes}
                onChange={formik.handleChange}
                error={formik.errors.notes}
              />
            </div>
            <Button
              isLoading={isLoading}
              btnText={t("contactus.submitButton")}
              btnStyle={formik.isValid ? "primary" : "disabled"}
              btnType="submit"
              className="w-full"
            />
          </form>
        </div>
      </div>
    </>
  );
};
export default ContactUs;
